<template xmlns:cursor="http://www.w3.org/1999/xhtml">
  <div v-bind="$attrs" class="container is-max-widescreen">
    <nav class="breadcrumb has-dot-separator column is-full" aria-label="breadcrumbs">
      <ul>
        <li class=""><a v-on:click="navigateTo('')" aria-current="page">
            <span class="icon is-small">
              <i class="fas fa-home" aria-hidden="true"></i>
            </span>
            Home
          </a></li>
        <li><a v-on:click="navigateTo('products')">
            <span class="icon is-small">
              <i class="fas fa-list" aria-hidden="true"></i>
            </span>
            Products
          </a></li>
        <li class=""><a href="" aria-current="page">
            <span class="icon is-small">
              <i class="fas fa-fire" aria-hidden="true"></i>
            </span>
            Featured
          </a></li>
        <li class=""><a v-on:click="navigateTo('stats')" aria-current="page">
            <span class="icon is-small">
              <i class="far fa-chart-bar" aria-hidden="true"></i>
            </span>
            Stats
          </a></li>
        <li class=""><a v-on:click="navigateTo('comparator')" aria-current="page">
            <span class="icon is-small">
              <i class="fas fa-balance-scale-left" aria-hidden="true"></i>
            </span>
            Comparator
          </a></li>
        <li class=""><a v-bind:href="'https://patreon.com/PersonaExplorer'" target="_blank" aria-current="page">
            <span class="icon is-small">
              <i class="fas fa-star"></i>
            </span>
            Premium Subscription
          </a></li>
      </ul>
    </nav>

    <div class="column is-full has-text-centered">
      <h5 class="has-text-white is-italic">Every Tuesday, the different sections of the
        Dressing Room are updated with new items.<br> You will find on this page the history
        of these sections, either by week, or by section name.
      </h5>
    </div>


    <div v-if="$auth.isAuthenticated.value && isPremiumAccount" class="columns is-multiline is-centered is-marginless">
      <div class="column is-two-fifths">
        <label class="label has-text-white">Search</label>
        <div class="field">
          <p class="control is-expanded has-icons -right has-text-white">
            <input class="input has-text-white" type="search" placeholder="Enter Item Name..."
              v-debounce:500ms="searchHandler" v-model="searchTerm" />
          </p>
        </div>
      </div>
      <div class="column is-one-fifth">
        <label class="label has-text-white">Filter Data By</label>
        <span class="select selector">
          <select class="custom-select" @change="onChange($event)" v-model="filterMode">
            <option cursor:pointer value="Period">Time Period</option>
            <option cursor:pointer value="Category">Section</option>
          </select>
        </span>
      </div>

      <div v-if="filterMode === 'Period'" class="column is-two-fifths">
        <label class="label has-text-white">Time Period</label>
        <span class="select selector">
          <select id="select" class="custom-select" @change="onChange($event)" v-model="dateDataSelected">
            <option cursor:pointer v-for="option in dateData" :key="option.id" :value="option.id">
              {{ option.label }}
            </option>
          </select>
        </span>
      </div>

      <div v-else class="column is-two-fifths">
        <label class="label has-text-white">Section</label>
        <span class="select selector">
          <select class="custom-select" @change="onChange($event)" v-model="categorySelected">
            <option cursor:pointer value="DressingRoomFeaturedQuery">Dressing Room & Profile (without first party items)
            </option>
            <option cursor:pointer value="Top">Top</option>
            <option cursor:pointer value="Bottom">Bottom</option>
            <option cursor:pointer value="Outerwear">Outerwear</option>
            <option cursor:pointer value="Headwear">Headwear</option>
            <option cursor:pointer value="Gloves">Gloves</option>
            <option cursor:pointer value="Feet">Feet</option>
            <option cursor:pointer value="Face Accessory">Face Accessory</option>
            <option cursor:pointer value="Back Accessory">Back Accessory</option>
            <option cursor:pointer value="Profile Featured">Profile</option>
          </select>
        </span>
      </div>

      <div class="column is-full has-text-white">
        <br>
      </div>

      <div class="colomn" style="width: 100%" v-for="data in jsonToRender" :key="data.key">
        <h3 class="has-text-white has-text-weight-bold is-italic" style="margin-bottom: 10px;">
          {{ data.title }} </h3>
        <div class="columns specialrow" style="margin-bottom: 30px;">
          <div class="column is-2" v-for="pieceData in data['pieces']" :key="pieceData.id">
            <PersonaItemCard :pieceOfContent="pieceData" :isPremium=isPremiumAccount :clickable="false" />
          </div>
        </div>
      </div>

      <div
        v-if="filterMode === 'Category' && hasMoreCategoryRows"
        ref="loadMoreSentinel"
        class="column is-full has-text-centered featured-load-more"
      >
        <span class="has-text-grey-light">
          {{ isAppendingCategoryRows ? "Loading more weeks..." : "Scroll down to load more weeks" }}
        </span>
      </div>
    </div>
    <div v-else-if="$auth.isAuthenticated.value && !isPremiumAccount"
      class="column-error column is-full has-text-centered">
      <p class="has-text-white">You need a Premium subscription to this this page.</p>
      <p class="has-text-white">Subscribe here: <a href="https://patreon.com/PersonaExplorer"
          target="_blank">https://patreon.com/PersonaExplorer</a></p>
    </div>
    <div v-else class="column-error column is-full has-text-centered">
      <!-- <p class="has-text-white">Please login to see this page (access restricted to <strong>Premium</strong> users only). </p> -->
      <p class="has-text-white">Please login to see this page. </p>
    </div>
  </div>
</template>

<script>
import PersonaItemCard from '../components/PersonaItemCard.vue'
import { useMeta } from "vue-meta";

const TAG_TYPES = ["orTags", "andTags", "productIds"];
const INITIAL_CATEGORY_ROWS = 4;
const CATEGORY_ROWS_PER_LOAD = 4;
const CATEGORY_OPTIONS = [
  { value: "Top", index: 0, fallbackTitle: "Top" },
  { value: "Bottom", index: 1, fallbackTitle: "Bottom" },
  { value: "Outerwear", index: 2, fallbackTitle: "Outerwear" },
  { value: "Headwear", index: 3, fallbackTitle: "Headwear" },
  { value: "Gloves", index: 4, fallbackTitle: "Gloves" },
  { value: "Feet", index: 5, fallbackTitle: "Feet" },
  { value: "Face Accessory", index: 6, fallbackTitle: "Face Accessory" },
  { value: "Back Accessory", index: 7, fallbackTitle: "Back Accessory" }
];

export default {
  name: 'FeaturedView',
  props: {
    isPremiumAccount: Boolean,
    jsonData: Object
  },
  setup() {
    useMeta({
      title: 'Featured',
      htmlAttrs: { lang: 'en', amp: true }
    })
  },
  data() {
    return {
      categorySelected: "DressingRoomFeaturedQuery",
      dateDataSelected: "",
      dateData: [],
      filterMode: "Period",
      jsonToRender: [],
      pathToData: 0,
      searchTerm: "",
      featuredResultsCache: [],
      featuredResultsSource: null,
      featuredResultById: {},
      featuredSectionCache: {},
      activeRenderJobId: 0,
      loadMoreObserver: null,
      categoryRowsSourceResults: [],
      categoryRowsBuilder: null,
      categoryRowsFilterOptions: {},
      categoryRowsSearchNeedle: "",
      categoryRowsKeyPrefix: "",
      categoryNextResultIndex: 0,
      categoryLastRenderedDate: null,
      hasMoreCategoryRows: false,
      isAppendingCategoryRows: false
    }
  },
  components: {
    PersonaItemCard
  },
  mounted() {
    this.updatePage()
  },
  beforeUnmount() {
    this.clearPageData()
    this.disconnectLoadMoreObserver()
  },
  watch: {
    isPremiumAccount: function (newVal) {
      if (newVal) {
        this.resetFeaturedCache()
        this.updatePage()
      } else {
        this.clearPageData()
      }
    },
    'jsonData.FeaturedData': function () {
      this.resetFeaturedCache()
      this.updatePage()
    }
  },
  methods: {
    navigateTo(path) {
      this.$router.push({ path: "/" + path })
    },
    clearPageData() {
      this.stopActiveRender()
      this.dateData = []
      this.dateDataSelected = ""
      this.jsonToRender = []
      this.resetCategoryPagination()
    },
    resetFeaturedCache() {
      this.featuredResultsCache = []
      this.featuredResultsSource = null
      this.featuredResultById = {}
      this.featuredSectionCache = {}
    },
    stopActiveRender() {
      this.activeRenderJobId += 1
      this.isAppendingCategoryRows = false
      this.disconnectLoadMoreObserver()
      return this.activeRenderJobId
    },
    resetCategoryPagination() {
      this.categoryRowsSourceResults = []
      this.categoryRowsBuilder = null
      this.categoryRowsFilterOptions = {}
      this.categoryRowsSearchNeedle = ""
      this.categoryRowsKeyPrefix = ""
      this.categoryNextResultIndex = 0
      this.categoryLastRenderedDate = null
      this.hasMoreCategoryRows = false
      this.isAppendingCategoryRows = false
      this.disconnectLoadMoreObserver()
    },
    disconnectLoadMoreObserver() {
      if (this.loadMoreObserver) {
        this.loadMoreObserver.disconnect()
      }
    },
    observeLoadMoreSentinel() {
      if (typeof window === "undefined" || typeof window.IntersectionObserver !== "function") {
        return
      }

      if (this.filterMode !== "Category" || !this.hasMoreCategoryRows) {
        return
      }

      this.$nextTick(() => {
        if (this.filterMode !== "Category" || !this.hasMoreCategoryRows) {
          return
        }

        const sentinel = this.$refs.loadMoreSentinel

        if (!sentinel) {
          return
        }

        if (!this.loadMoreObserver) {
          this.loadMoreObserver = new window.IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.appendNextCategoryRows()
            }
          })
        } else {
          this.loadMoreObserver.disconnect()
        }

        this.loadMoreObserver.observe(sentinel)
      })
    },
    onChange() {
      this.updatePage()
    },
    searchHandler() {
      this.updatePage()
    },
    lookForPiece(id) {
      if (this.jsonData["Pieces"][id]) {
        return this.jsonData["Pieces"][id]
      } else {
        return false
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getNextTuesdayAfterDate(d) {
      let days = 0;
      let tempDate = new Date(d);
      if (tempDate.getDay() <= 2) {
        days = 2 - tempDate.getDay();
      } else {
        days = 7 - tempDate.getDay() + 2;
      }
      return new Date(tempDate.setDate(tempDate.getDate() + days));
    },
    getFeaturedManifestDate(dateValue) {
      const dateFormatted = new Date(dateValue)

      if (Number.isNaN(dateFormatted.getTime()) || dateFormatted.getFullYear() <= 2020) {
        return null
      }

      const nextTuesday = this.getNextTuesdayAfterDate(dateFormatted)

      if (nextTuesday.getDate() < dateFormatted.getDate()) {
        const monthStart = new Date(nextTuesday)
        monthStart.setDate(1)
        return monthStart
      }

      return nextTuesday
    },
    getRangeEndDate(dateValue) {
      const dateFormatted = new Date(dateValue)
      const weekAfterDate = new Date(dateFormatted)
      weekAfterDate.setDate(weekAfterDate.getDate() + 7)

      if (weekAfterDate.getDate() < dateFormatted.getDate()) {
        const monthBoundary = new Date(dateFormatted)
        monthBoundary.setDate(31)
        return monthBoundary
      }

      const nextDay = new Date(dateFormatted)
      nextDay.setDate(nextDay.getDate() + 1)
      return this.getNextTuesdayAfterDate(nextDay)
    },
    formatDateRange(dateValue, rangeEndDate = null) {
      const endDate = rangeEndDate || this.getRangeEndDate(dateValue)
      return `${dateValue.toDateString()} - ${endDate.toDateString()}`
    },
    getSearchNeedle() {
      return this.searchTerm.trim().toLowerCase()
    },
    pieceMatchesFilters(pieceInfo, searchNeedle, options = {}) {
      if (!pieceInfo) {
        return false
      }

      if (options.excludeCreator && pieceInfo.displayProperties?.creatorName === options.excludeCreator) {
        return false
      }

      if (options.excludeFirstParty && pieceInfo.extraTags?.includes("first_party")) {
        return false
      }

      if (searchNeedle && !pieceInfo.title?.neutral?.toLowerCase().includes(searchNeedle)) {
        return false
      }

      return true
    },
    filterPieces(pieces, searchNeedle, options = {}) {
      return pieces.filter((pieceInfo) => this.pieceMatchesFilters(pieceInfo, searchNeedle, options))
    },
    collectQueryPieces(queryData) {
      const pieces = []

      if (!queryData) {
        return pieces
      }

      for (const tagType of TAG_TYPES) {
        const tagItems = queryData[tagType] || []

        for (const tagItem of tagItems) {
          const pieceInfo = this.lookForPiece(tagItem)

          if (pieceInfo !== false) {
            pieces.push(pieceInfo)
          }
        }
      }

      return pieces
    },
    collectPeriodCategoryData(result, categoryOption) {
      const pieces = []
      let sectionTitle = categoryOption.fallbackTitle
      const categoryIndices = [0, 1]

      for (const categoryIndex of categoryIndices) {
        const subCategory = result.displayProperties?.dressingRoomLayout?.categoryObjects?.[categoryIndex]?.subCategories?.[categoryOption.index]

        if (!subCategory) {
          continue
        }

        const rawTitle = subCategory.title?.split(".")?.[2]
        if (rawTitle) {
          sectionTitle = this.capitalizeFirstLetter(rawTitle)
        }

        pieces.push(...this.collectQueryPieces(subCategory.featuredQuery))
      }

      return {
        title: sectionTitle,
        pieces
      }
    },
    collectCategoryHistoryPieces(result, categoryIndex) {
      const pieces = []
      const legacyQuery = result.displayProperties?.dressingRoomLayout?.categoryObjects?.[1]?.subCategories?.[categoryIndex]?.featuredQuery
      const modernQuery = result.displayProperties?.dressingRoomLayout?.categoryObjects?.[0]?.subCategories?.[categoryIndex]?.featuredQuery

      if (legacyQuery?.productIds) {
        pieces.push(...this.collectQueryPieces({ productIds: legacyQuery.productIds }))
      }

      pieces.push(...this.collectQueryPieces(modernQuery))

      return pieces
    },
    buildResultSectionCache(result) {
      const dressingRoomLayout = result.displayProperties?.dressingRoomLayout || {}
      const profilePieces = this.collectQueryPieces(dressingRoomLayout.profileFeaturedQuery)
      const dressingRoomPieces = this.collectQueryPieces(dressingRoomLayout.dressingRoomFeaturedQuery)

      return {
        profilePieces,
        dressingRoomPieces,
        combinedFeaturedPieces: profilePieces.concat(dressingRoomPieces),
        periodCategories: CATEGORY_OPTIONS.map((categoryOption) => this.collectPeriodCategoryData(result, categoryOption)),
        categoryHistoryPieces: CATEGORY_OPTIONS.map((categoryOption) => this.collectCategoryHistoryPieces(result, categoryOption.index))
      }
    },
    getResultSectionCache(result) {
      const cacheKey = String(result.id)

      if (!this.featuredSectionCache[cacheKey]) {
        this.featuredSectionCache[cacheKey] = this.buildResultSectionCache(result)
      }

      return this.featuredSectionCache[cacheKey]
    },
    getSortedFeaturedResults() {
      const results = this.jsonData?.FeaturedData?.results

      if (!Array.isArray(results)) {
        return []
      }

      if (this.featuredResultsSource === results && this.featuredResultsCache.length > 0) {
        return this.featuredResultsCache
      }

      const sortedResults = results
        .map((result) => {
          const featuredDate = this.getFeaturedManifestDate(result.creationDate)

          if (!featuredDate) {
            return null
          }

          return {
            ...result,
            _featuredDate: featuredDate
          }
        })
        .filter((result) => result !== null)
        .sort((first, second) => {
          const dateDifference = second._featuredDate - first._featuredDate

          if (dateDifference !== 0) {
            return dateDifference
          }

          return new Date(second.creationDate) - new Date(first.creationDate)
        })

      this.featuredResultsSource = results
      this.featuredResultsCache = sortedResults
      this.featuredResultById = Object.fromEntries(sortedResults.map((result) => [String(result.id), result]))

      let lastDate = null
      this.dateData = sortedResults.map((result) => {
        const option = {
          id: String(result.id),
          label: this.formatDateRange(result._featuredDate, lastDate)
        }

        lastDate = result._featuredDate
        return option
      })

      if (!this.dateData.some((option) => option.id === this.dateDataSelected)) {
        this.dateDataSelected = this.dateData[0]?.id || ""
      }

      return sortedResults
    },
    buildPeriodData(result, searchNeedle) {
      if (!result) {
        return []
      }

      const tempData = []
      const sectionCache = this.getResultSectionCache(result)
      const profilePieces = this.filterPieces(sectionCache.profilePieces, searchNeedle)

      if (profilePieces.length > 0) {
        tempData.push({
          key: `${result.id}-profile`,
          title: "Profile",
          pieces: profilePieces,
          date: result._featuredDate
        })
      }

      const dressingRoomPieces = this.filterPieces(sectionCache.dressingRoomPieces, searchNeedle)

      if (dressingRoomPieces.length > 0) {
        tempData.push({
          key: `${result.id}-dressing-room`,
          title: "Dressing Room",
          pieces: dressingRoomPieces,
          date: result._featuredDate
        })
      }

      sectionCache.periodCategories.forEach((categoryData, index) => {
        const categoryPieces = this.filterPieces(categoryData.pieces, searchNeedle)

        if (categoryPieces.length > 0) {
          tempData.push({
            key: `${result.id}-category-${index}`,
            title: categoryData.title,
            pieces: categoryPieces,
            date: result._featuredDate
          })
        }
      })

      return tempData
    },
    setupCategoryPagination(results, searchNeedle, rowKeyPrefix, piecesBuilder, filterOptions = {}, renderJobId) {
      if (renderJobId !== this.activeRenderJobId) {
        return
      }

      this.categoryRowsSourceResults = results
      this.categoryRowsBuilder = piecesBuilder
      this.categoryRowsFilterOptions = filterOptions
      this.categoryRowsSearchNeedle = searchNeedle
      this.categoryRowsKeyPrefix = rowKeyPrefix
      this.categoryNextResultIndex = 0
      this.categoryLastRenderedDate = null
      this.hasMoreCategoryRows = results.length > 0

      this.appendNextCategoryRows(INITIAL_CATEGORY_ROWS, renderJobId)
    },
    appendNextCategoryRows(rowCount = CATEGORY_ROWS_PER_LOAD, renderJobId = this.activeRenderJobId) {
      if (renderJobId !== this.activeRenderJobId || this.isAppendingCategoryRows || !this.categoryRowsBuilder) {
        return
      }

      if (!this.hasMoreCategoryRows) {
        this.disconnectLoadMoreObserver()
        return
      }

      this.isAppendingCategoryRows = true
      let rowsAdded = 0

      while (this.categoryNextResultIndex < this.categoryRowsSourceResults.length && rowsAdded < rowCount) {
        if (renderJobId !== this.activeRenderJobId) {
          break
        }

        const result = this.categoryRowsSourceResults[this.categoryNextResultIndex]
        this.categoryNextResultIndex += 1

        const sectionCache = this.getResultSectionCache(result)
        const pieces = this.filterPieces(
          this.categoryRowsBuilder(result, sectionCache),
          this.categoryRowsSearchNeedle,
          this.categoryRowsFilterOptions
        )

        if (pieces.length === 0) {
          continue
        }

        this.jsonToRender.push({
          key: `${this.categoryRowsKeyPrefix}-${result.id}`,
          title: this.formatDateRange(result._featuredDate, this.categoryLastRenderedDate),
          pieces,
          date: result._featuredDate
        })

        this.categoryLastRenderedDate = result._featuredDate
        rowsAdded += 1
      }

      this.hasMoreCategoryRows = this.categoryNextResultIndex < this.categoryRowsSourceResults.length
      this.isAppendingCategoryRows = false

      if (renderJobId !== this.activeRenderJobId) {
        return
      }

      if (this.hasMoreCategoryRows) {
        this.observeLoadMoreSentinel()
      } else {
        this.disconnectLoadMoreObserver()
      }
    },
    getCategoryPath() {
      if (this.categorySelected === "dressingRoomFeaturedQuery" || this.categorySelected === "DressingRoomFeaturedQuery") {
        return 0
      }

      if (this.categorySelected === "Profile Featured") {
        return 1
      }

      return CATEGORY_OPTIONS.find((categoryOption) => categoryOption.value === this.categorySelected)?.index ?? 0
    },
    updatePage() {
      const renderJobId = this.stopActiveRender()
      this.resetCategoryPagination()

      if (!this.isPremiumAccount) {
        this.dateData = []
        this.dateDataSelected = ""
        this.jsonToRender = []
        return
      }

      const featuredResults = this.getSortedFeaturedResults()

      if (featuredResults.length === 0) {
        this.dateData = []
        this.dateDataSelected = ""
        this.jsonToRender = []
        return
      }

      const searchNeedle = this.getSearchNeedle()

      if (this.filterMode === "Period") {
        const selectedResult = this.featuredResultById[String(this.dateDataSelected)] || featuredResults[0]

        this.dateDataSelected = selectedResult ? String(selectedResult.id) : ""
        this.jsonToRender = this.buildPeriodData(selectedResult, searchNeedle)
        return
      }

      const categoryPath = this.getCategoryPath()
      const rowKeyPrefix = this.categorySelected
      this.pathToData = categoryPath
      this.jsonToRender = []

      if (this.categorySelected === "dressingRoomFeaturedQuery" || this.categorySelected === "DressingRoomFeaturedQuery") {
        this.setupCategoryPagination(
          featuredResults,
          searchNeedle,
          rowKeyPrefix,
          (result, sectionCache) => sectionCache.combinedFeaturedPieces,
          { excludeCreator: "Minecraft", excludeFirstParty: true },
          renderJobId
        )
        return
      }

      if (this.categorySelected === "Profile Featured") {
        this.setupCategoryPagination(
          featuredResults,
          searchNeedle,
          rowKeyPrefix,
          (result, sectionCache) => sectionCache.profilePieces,
          {},
          renderJobId
        )
        return
      }

      this.setupCategoryPagination(
        featuredResults,
        searchNeedle,
        rowKeyPrefix,
        (result, sectionCache) => sectionCache.categoryHistoryPieces[categoryPath] || [],
        {},
        renderJobId
      )
    }
  }
}
</script>

<style scoped>
.select {
  -webkit-box-align: center;
  -webkit-box-pack: start;
  float: none;
}

.specialrow {
  margin-top: auto;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  flex-wrap: nowrap !important;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.featured-load-more {
  padding-bottom: 2rem;
}
</style>
